import { combineReducers } from 'redux'
import { FOLLOWING_USER, UNFOLLOWING_USER } from '../actions/constants/users'
import {
  FETCHING_AMBASSADOR_AUDIENCE,
  RECEIVED_AMBASSADOR_AUDIENCE,
  ERROR_FETCHING_AMBASSADOR_AUDIENCE
} from '../actions/constants/ambassadors'
import * as actions from '../actions'

const all = (state = { step: '' }, action) => {
  const ambObj = {}

  switch (action.type) {
    case RECEIVED_AMBASSADOR_AUDIENCE:
      return {
        ...state,
        ...action.data.reduce((obj, user) => {
          const objCopy = { ...obj }
          objCopy[user._id] = user
          return objCopy
        }, {})
      }
    case actions.RECEIVED_AMBASSADOR:
      ambObj[action.data._id] = action.data
      return {
        ...state,
        ...ambObj
      }
    case actions.SET_NEXT_STEP:
      return {
        ...state,
        step: action.step
      }
    case actions.UPDATED_AMBASSADOR:
      return {
        ...state,
        [action._id]: { ...state[action._id], ...action.value, isUpdated: true }
      }
    default:
      return state
  }
}

const defaultForm = {
  isLoading: false,
  error: false,
  submitSuccess: false,
  firstName: '',
  lastName: '',
  username: '',
  user: '',
  token: '',
  email: '',
  facebook: '',
  instagram: '',
  tiktok: '',
  twitter: '',
  youtube: '',
  website: '',
  country: '',
  city: '',
  interests: '',
  favorites: '',
  remarks: '',
  errors: {}
}

const form = (state = defaultForm, action) => {
  switch (action.type) {
    case actions.UPDATE_FORM_AMBASSADOR:
      return {
        ...state,
        [action.category]: action.value
      }
    case actions.SUBMITTING_AMBASSADOR_FORM:
      return {
        ...state,
        isLoading: true
      }
    case actions.SUBMITTED_AMBASSADOR_FORM:
      return {
        ...state,
        isLoading: false,
        error: false,
        submitSuccess: true
      }
    case actions.ERROR_SUBMITTING_AMBASSADOR_FORM:
      return {
        ...state,
        isLoading: false,
        error: true
      }
    default:
      return state
  }
}

// TODO fix
// eslint-disable-next-line complexity
const ambassador = (
  state = {
    isLoading: false,
    isUpdated: false,
    _id: '',
    error: false
  },
  action
) => {
  switch (action.type) {
    case actions.RESET_AMBASSADOR:
      return {
        ...state,
        isUpdated: false
      }
    case actions.UPDATING_AMBASSADOR:
      return {
        ...state,
        isLoading: true
      }
    case actions.UPDATED_AMBASSADOR:
      return {
        ...state,
        isLoading: false,
        isUpdated: true,
        ...action.value
      }
    case actions.ERROR_UPDATING_AMBASSADOR:
      return {
        ...state,
        isLoading: false,
        error: true
      }
    case actions.FETCHING_AMBASSADOR:
      return {
        ...state,
        isLoading: true,
        _id: '',
        error: false
      }
    case actions.RECEIVED_AMBASSADOR:
      return {
        ...state,
        isLoading: false,
        error: false,
        ...action.data
      }
    case actions.ERROR_FETCHING_AMBASSADOR:
      return {
        ...state,
        isLoading: false,
        error: true
      }
    default:
      return state
  }
}

const audience = (
  state = {
    isLoading: false,
    all: {},
    items: [],
    fetched: false,
    error: false
  },
  action
) => {
  switch (action.type) {
    case FETCHING_AMBASSADOR_AUDIENCE:
      return {
        ...state,
        isLoading: true,
        items: [],
        error: false
      }
    case RECEIVED_AMBASSADOR_AUDIENCE:
      return {
        ...state,
        isLoading: false,
        all: action.data.reduce((obj, user) => {
          const objCopy = { ...obj }
          objCopy[user._id] = user
          return objCopy
        }, {}),
        items: action.data.map((user) => user._id),
        error: false,
        fetched: true
      }
    case ERROR_FETCHING_AMBASSADOR_AUDIENCE:
      return {
        ...state,
        isLoading: false,
        error: true
      }
    case FOLLOWING_USER:
      return {
        ...state,
        all: {
          ...state.all,
          [action.userID]: {
            ...state.all[action.userID],
            isFollowed: true
          }
        }
      }
    case UNFOLLOWING_USER:
      return {
        ...state,
        all: {
          ...state.all,
          [action.userID]: {
            ...state.all[action.userID],
            isFollowed: false
          }
        }
      }
    default:
      return state
  }
}

const campaigns = (
  state = {
    isLoading: false,
    items: [],
    error: false,
    fetched: false
  },
  action
) => {
  switch (action.type) {
    case actions.FETCHING_AMBASSADOR_CAMPAIGNS:
      return {
        ...state,
        isLoading: true,
        items: [],
        error: false
      }
    case actions.RECEIVED_AMBASSADOR_CAMPAIGNS:
      return {
        ...state,
        isLoading: false,
        fetched: true,
        items: action.data,
        error: false
      }
    case actions.ERROR_FETCHING_AMBASSADOR_CAMPAIGNS:
      return {
        ...state,
        isLoading: false,
        error: true
      }
    default:
      return state
  }
}

// TODO fix
// eslint-disable-next-line complexity
const payments = (
  state = {
    isLoading: false,
    items: [],
    totalPayments: 0,
    error: false,
    fetched: false
  },
  action
) => {
  switch (action.type) {
    case actions.FETCHING_AMBASSADOR_PAYMENTS:
      return {
        ...state,
        isLoading: true,
        items: [],
        error: false
      }
    case actions.RECEIVED_AMBASSADOR_PAYMENTS:
      return {
        ...state,
        isLoading: false,
        fetched: true,
        items: action.data[0].combined,
        totalPayments: action.data[0].totalPayments.length
          ? action.data[0].totalPayments[0].totalPayment
          : 0,
        error: false
      }
    case actions.CREATING_PENDING_PAYMENT:
      return {
        ...state,
        isLoading: true
      }
    case actions.ADD_PENDING_PAYMENT:
      return {
        ...state,
        isLoading: false,
        items: state.items.concat(action.payment)
      }
    case actions.ERROR_FETCHING_AMBASSADOR_PAYMENTS:
      return {
        ...state,
        isLoading: false,
        error: true
      }
    default:
      return state
  }
}

export default combineReducers({
  all,
  form,
  audience,
  ambassador,
  campaigns,
  payments
})
